import { createGlobalStyle } from "styled-components";
import reboot from "styled-reboot";

import {
  BODY_WHITE_BG_CLASS,
  BODY_FOCUS_MODE_CLASS,
  IS_OVERLAY_OPEN_CLASS_NAME,
  IS_MODAL_OPEN_CLASS_NAME,
} from "@config/consts";

import "@batmaid/design-tokens/fonts/fellix/styles/all.css";

import theme from "@ui/themes/default";

export const defaultOptions = {
  bodyBg: theme.palette.white,
  black: theme.palette.grey800,
  fontFamilyBase: theme.fonts.base,
  fontSizeBase: theme.fonts.baseSize,
  linkColor: theme.palette.blue500,
  linkHoverColor: theme.palette.blue500,
};

const GlobalStyle = createGlobalStyle<{ backgroundColor?: string }>`
  ${reboot(defaultOptions)}

  * {
    -webkit-tap-highlight-color: transparent;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }
    
  html {
    font-size: ${theme.fonts.baseSize};
  }
  
  body {
    font-size: ${theme.fonts.sizes.body2};
    font-variation-settings: "wdth" 100;
    letter-spacing: ${theme.fonts.letterSpacings.normal};
    color: ${theme.palette.grey800};
    background-color: ${props =>
      props.backgroundColor || defaultOptions.bodyBg};

    &.scroll-smooth {
      scroll-behavior: smooth;
    }

    &.${IS_MODAL_OPEN_CLASS_NAME},
    &.${IS_OVERLAY_OPEN_CLASS_NAME} {
      overflow: hidden;

      // fix for iOS scrolling issue
      @supports (-webkit-overflow-scrolling: touch) {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
    }

    &.${BODY_WHITE_BG_CLASS} {
        background-color: ${theme.palette.white};
    }

    &.${BODY_FOCUS_MODE_CLASS} {
        background-color: ${theme.palette.white};

      #header,
      #footer,
      #bottom-nav,
      #bottom-nav-spacer {
        display: none;
      }

      #main {
        overflow: hidden;
      }

      #footer {
        ${theme.breakpoints.desktop} {
          display: block;
        }
      }
    }
  }

  ul {
    color: ${theme.palette.grey800};
  }

  button {
    cursor: pointer;
    background: none;
    border: 0;
  }


  button:active,
  button:focus {
    outline: 0;
  }

  a:hover {
    text-decoration: none;
  }

  input:disabled {
    opacity: 1;
  }
 
  @media all and (display-mode: standalone) {
    body {
      -webkit-user-select: none;
      -webkit-touch-callout: none;
    }
    
    * {
      -webkit-overflow-scrolling: auto; 
    }

    *::-webkit-scrollbar {
      width: 0px;
    }
  }
  
  .headless {
    #header,
    #footer,
    #bottom-nav,
    #bottom-nav-spacer {
      display: none;
    }
  }
`;

export { GlobalStyle as default };
